<template>
  <div class="flower" @click="closeOverlay">
    <!-- 全屏透明蒙版 -->
    <!-- <div class="flower-overlay" @click="fullOverlayHandle"></div> -->
    <!-- {{ overlayShow }}{{ type }}{{ index }} -->
    <div class="flower-one">
      <!-- <div
          :key="index"
          class="flower-one-item"
          :ref="`flower-item-${index + 1}`"
          @click="itemHandle(index + 1, item)"
        > -->
      <div
        v-for="(item, index) in list"
        :key="index"
        class="flower-one-item"
        :ref="`flower-item-${index + 1}`"
      >
        <!-- <img
            v-if="index != 6 && index != 2 && index != 5"
            :src="getImgSource(index + 1)"
            alt=""
            srcset=""
          /> -->
        <SvgIcon
          v-if="type == 'one'"
          :name="`${index + 1}_${item.children.length}`"
          :len="1"
          :index="index + 1"
          @svgClickItem="svgClickItem"
        />
        <template v-else>
          <SvgIcon
            v-if="index == 0 && currentType.id != list[0].id"
            :name="`${index + 1}_${item.children.length}`"
            :len="1"
            :index="index + 1"
            @svgClickItem="svgClickItem"
          />

          <SvgIcon
            v-else
            :name="`${index + 1}_${item.children.length}`"
            :len="item.children.length"
            :index="index + 1"
            @svgClickItem="svgClickItem"
          />
        </template>
        <div
          v-if="type == 'one'"
          class="flower-one-item-text"
          v-html="item.name"
        ></div>
        <template v-if="type == 'two'">
          <!-- 为第二个类型选择时，显示第一个元素 -->
          <template v-if="index + 1 == 1">
            <template v-if="currentType.id != 1">
              <div class="flower-one-item-text" v-html="currentType.name"></div>
            </template>
            <template v-else>
              <div
                class="flower-one-item-one"
                v-if="currentType.children.length == 1"
              >
                <div
                  class="flower-one-item-one-text my-shop-btn"
                  v-for="subItem in currentType.children"
                  v-html="subItem.name"
                  @click.stop="secondItemHandle(subItem)"
                  :key="subItem"
                ></div>
              </div>
              <div
                class="flower-one-item-two"
                v-else-if="currentType.children.length == 2"
              >
                <div
                  class="flower-one-item-two-text my-shop-btn"
                  v-for="subItem in currentType.children"
                  v-html="subItem.name"
                  @click.stop="secondItemHandle(subItem)"
                  :key="subItem"
                ></div>
              </div>
              <div class="flower-one-item-three" v-else>
                <div
                  class="flower-one-item-three-text my-shop-btn"
                  v-for="subItem in currentType.children"
                  v-html="subItem.name"
                  @click.prevent="secondItemHandle(subItem)"
                  :key="subItem"
                ></div>
              </div>
            </template>
          </template>
          <template v-else>
            <!-- <div
                class="flower-one-item-one"
                v-if="currentType.children.length == 1 && index != 6 && index != 2"
              > -->
            <div
              class="flower-one-item-one"
              v-if="currentType.children.length == 1"
            >
              <div
                class="flower-one-item-one-text my-shop-btn"
                v-for="subItem in currentType.children"
                v-html="subItem.name"
                @click.stop="secondItemHandle(subItem)"
                :key="subItem"
              ></div>
            </div>
            <div
              class="flower-one-item-two"
              v-else-if="currentType.children.length == 2"
            >
              <div
                class="flower-one-item-two-text my-shop-btn"
                v-for="subItem in currentType.children"
                v-html="subItem.name"
                @click.stop="secondItemHandle(subItem)"
                :key="subItem"
              ></div>
            </div>
            <div class="flower-one-item-three" v-else>
              <div
                class="flower-one-item-three-text my-shop-btn"
                v-for="subItem in currentType.children"
                v-html="subItem.name"
                @click.stop="secondItemHandle(subItem)"
                :key="subItem"
              ></div>
            </div>
          </template>
        </template>
      </div>
    </div>

    <div class="flower-one" style="z-index: 1">
      <div
        v-for="(item, index) in list"
        :key="index"
        class="flower-one-item"
        :ref="`flower-item-${index + 1}`"
        @click="itemHandle(index + 1, item)"
      >
        <img :src="getImgSource(index + 1)" alt="" srcset="" />
        <!-- <SvgIcon
            v-if="type == 'one'"
            :name="`${index + 1}_${item.children.length}`"
            :len="1"
            :index="index + 1"
          /> -->
        <div class="flower-one-item-text" v-html="item.name"></div>
      </div>
    </div>
    <Overlay @click="closeOverlay" :show="overlayShow"></Overlay>
  </div>
</template>

<script>
import { Overlay } from "vant";
import SvgIcon from "./SvgIcon.vue";
import { nextTick } from "vue";

export default {
  components: {
    Overlay,
    SvgIcon,
  },
  props: {
    list: { type: Array, default: () => [] },
  },
  data() {
    return {
      oneType: 0,
      type: "one",
      overlayShow: false,
      currentType: {},
      resultType: {},
      // list: [
      //   {
      //     createTime: "2024-01-11 15:23:32",
      //     updateTime: "2024-03-11 14:35:35",
      //     id: 1,
      //     name: "自我",
      //     level: 1,
      //     pid: 0,
      //     children: [
      //       {
      //         createTime: "2024-01-11 16:08:53",
      //         updateTime: null,
      //         id: 3,
      //         name: "自我",
      //         level: 2,
      //         pid: 1,
      //         children: [],
      //       },
      //       {
      //         createTime: "2024-01-11 16:08:53",
      //         updateTime: null,
      //         id: 3,
      //         name: "自我2",
      //         level: 2,
      //         pid: 1,
      //         children: [],
      //       },
      //       {
      //         createTime: "2024-01-11 16:08:53",
      //         updateTime: null,
      //         id: 3,
      //         name: "自我3",
      //         level: 2,
      //         pid: 1,
      //         children: [],
      //       },
      //     ],
      //   },
      //   {
      //     createTime: "2024-01-11 15:24:02",
      //     updateTime: null,
      //     id: 2,
      //     name: "娱乐",
      //     level: 1,
      //     pid: 0,
      //     children: [
      //       {
      //         createTime: "2024-01-11 16:09:31",
      //         updateTime: null,
      //         id: 5,
      //         name: "手机娱乐",
      //         level: 2,
      //         pid: 2,
      //         children: [],
      //       },
      //       {
      //         createTime: "2024-01-11 16:09:31",
      //         updateTime: null,
      //         id: 5,
      //         name: "手机娱乐2",
      //         level: 2,
      //         pid: 2,
      //         children: [],
      //       },
      //       {
      //         createTime: "2024-01-11 16:09:31",
      //         updateTime: null,
      //         id: 5,
      //         name: "手机娱乐3",
      //         level: 2,
      //         pid: 2,
      //         children: [],
      //       },
      //     ],
      //   },
      //   {
      //     createTime: "2024-01-11 16:44:06",
      //     updateTime: "2024-01-11 17:36:22",
      //     id: 7,
      //     name: "家庭系统",
      //     level: 1,
      //     pid: 0,
      //     children: [
      //       {
      //         createTime: "2024-01-11 17:50:22",
      //         updateTime: null,
      //         id: 16,
      //         name: "家庭环境",
      //         level: 2,
      //         pid: 7,
      //         children: [
      //           {
      //             createTime: "2024-03-11 15:04:24",
      //             updateTime: null,
      //             id: 63,
      //             name: "家长版",
      //             level: 3,
      //             pid: 16,
      //             children: [],
      //           },
      //         ],
      //       },
      //       {
      //         createTime: "2024-01-11 17:50:35",
      //         updateTime: null,
      //         id: 17,
      //         name: "教养方式",
      //         level: 2,
      //         pid: 7,
      //         children: [
      //           {
      //             createTime: "2024-03-06 17:30:19",
      //             updateTime: null,
      //             id: 64,
      //             name: "家长版",
      //             level: 3,
      //             pid: 17,
      //             children: [],
      //           },
      //         ],
      //       },
      //       {
      //         createTime: "2024-01-11 17:50:44",
      //         updateTime: null,
      //         id: 18,
      //         name: "PAC",
      //         level: 2,
      //         pid: 7,
      //         children: [
      //           {
      //             createTime: "2024-03-07 11:07:25",
      //             updateTime: null,
      //             id: 65,
      //             name: "家长版",
      //             level: 3,
      //             pid: 18,
      //             children: [],
      //           },
      //         ],
      //       },
      //     ],
      //   },
      //   {
      //     createTime: "2024-01-11 17:36:08",
      //     updateTime: null,
      //     id: 8,
      //     name: "学习",
      //     level: 1,
      //     pid: 0,
      //     children: [
      //       {
      //         createTime: "2024-01-11 17:51:03",
      //         updateTime: null,
      //         id: 19,
      //         name: "学习压力",
      //         level: 2,
      //         pid: 8,
      //         children: [],
      //       },
      //       {
      //         createTime: "2024-01-11 17:51:03",
      //         updateTime: null,
      //         id: 19,
      //         name: "学习压力2",
      //         level: 2,
      //         pid: 8,
      //         children: [],
      //       },
      //       {
      //         createTime: "2024-01-11 17:51:32",
      //         updateTime: null,
      //         id: 20,
      //         name: "学习内/外驱力",
      //         level: 2,
      //         pid: 8,
      //         children: [],
      //       },
      //     ],
      //   },
      //   {
      //     createTime: "2024-01-11 17:36:37",
      //     updateTime: null,
      //     id: 9,
      //     name: "师生关系",
      //     level: 1,
      //     pid: 0,
      //     children: [
      //       {
      //         createTime: "2024-01-11 17:52:01",
      //         updateTime: null,
      //         id: 21,
      //         name: "学校和老师",
      //         level: 2,
      //         pid: 9,
      //         children: [],
      //       },
      //       {
      //         createTime: "2024-01-11 17:52:01",
      //         updateTime: null,
      //         id: 21,
      //         name: "学校和老",
      //         level: 2,
      //         pid: 9,
      //         children: [],
      //       },
      //       {
      //         createTime: "2024-01-11 17:52:01",
      //         updateTime: null,
      //         id: 21,
      //         name: "学校和老2",
      //         level: 2,
      //         pid: 9,
      //         children: [],
      //       },
      //     ],
      //   },
      //   {
      //     createTime: "2024-01-11 17:36:45",
      //     updateTime: null,
      //     id: 10,
      //     name: "兴趣爱好",
      //     level: 1,
      //     pid: 0,
      //     children: [
      //       {
      //         createTime: "2024-01-11 17:52:15",
      //         updateTime: null,
      //         id: 22,
      //         name: "兴趣",
      //         level: 2,
      //         pid: 10,
      //         children: [],
      //       },
      //       {
      //         createTime: "2024-01-11 17:52:15",
      //         updateTime: null,
      //         id: 22,
      //         name: "兴趣2",
      //         level: 2,
      //         pid: 10,
      //         children: [],
      //       },
      //       {
      //         createTime: "2024-01-11 17:52:15",
      //         updateTime: null,
      //         id: 22,
      //         name: "兴趣3",
      //         level: 2,
      //         pid: 10,
      //         children: [],
      //       },
      //     ],
      //   },
      //   {
      //     createTime: "2024-01-11 17:36:51",
      //     updateTime: null,
      //     id: 11,
      //     name: "同伴",
      //     level: 1,
      //     pid: 0,
      //     children: [
      //       {
      //         createTime: "2024-01-11 17:49:13",
      //         updateTime: null,
      //         id: 15,
      //         name: "同伴",
      //         level: 2,
      //         pid: 11,
      //         children: [],
      //       },
      //       {
      //         createTime: "2024-01-11 17:49:13",
      //         updateTime: null,
      //         id: 15,
      //         name: "同伴2",
      //         level: 2,
      //         pid: 11,
      //         children: [],
      //       },
      //       {
      //         createTime: "2024-01-11 17:49:13",
      //         updateTime: null,
      //         id: 15,
      //         name: "同伴3",
      //         level: 2,
      //         pid: 11,
      //         children: [],
      //       },
      //     ],
      //   },
      //   {
      //     createTime: "2024-01-11 17:37:00",
      //     updateTime: null,
      //     id: 12,
      //     name: "异性",
      //     level: 1,
      //     pid: 0,
      //     children: [
      //       {
      //         createTime: "2024-01-11 17:37:00",
      //         updateTime: null,
      //         id: 12,
      //         name: "异性",
      //         level: 1,
      //         pid: 0,
      //         children: [],
      //       },
      //       {
      //         createTime: "2024-01-11 17:37:00",
      //         updateTime: null,
      //         id: 12,
      //         name: "异性2",
      //         level: 1,
      //         pid: 0,
      //         children: [],
      //       },
      //       {
      //         createTime: "2024-01-11 17:37:00",
      //         updateTime: null,
      //         id: 12,
      //         name: "异性3",
      //         level: 1,
      //         pid: 0,
      //         children: [],
      //       },
      //     ],
      //   },
      //   {
      //     createTime: "2024-01-11 17:37:05",
      //     updateTime: "2024-01-11 17:40:11",
      //     id: 13,
      //     name: "偶像",
      //     level: 1,
      //     pid: 0,
      //     children: [
      //       {
      //         createTime: "2024-01-11 17:43:31",
      //         updateTime: "2024-01-11 17:44:11",
      //         id: 14,
      //         name: "偶像",
      //         level: 2,
      //         pid: 13,
      //         children: [],
      //       },
      //       {
      //         createTime: "2024-04-02 14:56:32",
      //         updateTime: null,
      //         id: 80,
      //         name: "偶像2",
      //         level: 2,
      //         pid: 13,
      //         children: [],
      //       },
      //       {
      //         createTime: "2024-04-02 14:56:32",
      //         updateTime: null,
      //         id: 80,
      //         name: "偶像3",
      //         level: 2,
      //         pid: 13,
      //         children: [],
      //       },
      //     ],
      //   },
      // ],
    };
  },
  mounted() {},
  watch: {
    overlayShow: {
      handler(val) {
        console.log("val", val);
      },
      deep: true,
    },
  },
  methods: {
    svgClickItem(flowerIndex, index) {
      // if()

      // this.overlayShow = true;

      // type: 第几片花瓣， index: 花瓣的第几个类型
      // console.log(flowerIndex, index);
      if (this.type == "one") {
        const item = this.list[flowerIndex - 1];

        this.currentType = item;
        if (this.currentType.children.length == 0) {
          this.$emit("confirmResult", item);
          return;
        }
        this.type = "two";
        this.$emit("confirmFlower", item);
        this.overlayShow = true;
        // 取消原先的类型选中
        this.$emit("cancelResult");
        // 遍历
        for (let i = 0; i < this.list.length; i++) {
          // console.log(this.$refs[`flower-item-${i + 1}`][0])
          if (i === flowerIndex - 1) {
            if (flowerIndex == 1) {
              this.$refs[`flower-item-${i + 1}`][0].style =
                "display:block;scale: 2;top: 65%;left: 68%;";
            } else if (flowerIndex == 2) {
              this.$refs[`flower-item-${i + 1}`][0].style =
                "display:block;scale: 2;top: 50%;left: 69%;";
            } else if (flowerIndex == 3) {
              this.$refs[`flower-item-${i + 1}`][0].style =
                "display:block;scale: 2;top: 35%;left: 90%;";
            } else if (flowerIndex == 4) {
              this.$refs[`flower-item-${i + 1}`][0].style =
                "display:block;scale: 2;top: 66%;left: 90%;";
            } else if (flowerIndex == 5) {
              this.$refs[`flower-item-${i + 1}`][0].style =
                "display:block;scale: 2;top: 90%;left: 90%;";
            } else if (flowerIndex == 6) {
              this.$refs[`flower-item-${i + 1}`][0].style =
                "display:block;scale: 2;top: 85%;left: 70%;";
            } else if (flowerIndex == 7) {
              this.$refs[`flower-item-${i + 1}`][0].style =
                "display:block;scale: 2;top: 90%;;left: 50%;";
            } else if (flowerIndex == 8) {
              this.$refs[`flower-item-${i + 1}`][0].style =
                "display:block;scale: 2;top: 62%;left: 45%;";
            } else if (flowerIndex == 9) {
              this.$refs[`flower-item-${i + 1}`][0].style =
                "display:block;scale: 2;top: 50%;left: 45%;";
            }
          } else {
            this.$refs[`flower-item-${i + 1}`][0].style = "display:none;";

            if (flowerIndex != 1 && i + 1 == 1) {
              if (flowerIndex == 1) {
                // this.$refs[`flower-item-1`][0].style = "display:block;top: 60%;left: 60%;";
              } else if (flowerIndex == 2) {
                this.$refs[`flower-item-1`][0].style =
                  "display:block;top: 80%;left: 50%;";
              } else if (flowerIndex == 3) {
                this.$refs[`flower-item-1`][0].style =
                  "display:block;top: 65%;left: 30%;";
              } else if (flowerIndex == 4) {
                this.$refs[`flower-item-1`][0].style =
                  "display:block;top: 50%;left: 20%;";
              } else if (flowerIndex == 5) {
                this.$refs[`flower-item-1`][0].style =
                  "display:block;top: 30%;left: 30%;";
              } else if (flowerIndex == 6) {
                this.$refs[`flower-item-1`][0].style =
                  "display:block;top: 15%;left: 51%;";
              } else if (flowerIndex == 7) {
                this.$refs[`flower-item-1`][0].style =
                  "display:block;top: 30%;left: 80%;";
              } else if (flowerIndex == 8) {
                this.$refs[`flower-item-1`][0].style =
                  "display:block;top: 45%;left: 75%;";
              } else if (flowerIndex == 9) {
                this.$refs[`flower-item-1`][0].style =
                  "display:block;top: 79%;left: 70%;";
              }
            }
          }
        }
      } else {
        if (flowerIndex === 1 && this.currentType.id !== this.list[0].id) {
          return;
        }
        const item = this.list[flowerIndex - 1].children[index - 1];
        this.$toast(`当前选中类型为：${item.name}`);

        this.$emit("confirmResult", item);
      }

      // const item = this.list[flowerIndex - 1].children[index - 1];

      // // if()

      // this.$emit("confirmResult", item);
    },
    secondItemHandle(item) {
      // console.log("item", item)
      // this.type = "one";
      // this.overlayShow = false;
      // // 全部恢复
      // for (let i = 0; i < this.list.length; i++) {
      //   this.$refs[`flower-item-${i + 1}`][0].style = "display:block;";
      // }
      this.$emit("confirmResult", item);
    },
    getImgSource(path) {
      if (path > 9) return;
      return require(`@/assets/evaluation/test/${path}.png`);
    },
    itemHandle(index, item) {
      this.currentType = item;
      if (this.currentType.children.length == 0) {
        this.$emit("confirmResult", item);
        return;
      }

      if (this.type == "one") {
        // 取消原先的类型选中
        this.$emit("cancelResult");
        this.type = "two";
        this.overlayShow = true;
        // 遍历
        for (let i = 0; i < this.list.length; i++) {
          // console.log(this.$refs[`flower-item-${i + 1}`][0])
          if (i === index - 1) {
            if (index == 1) {
              this.$refs[`flower-item-${i + 1}`][0].style =
                "display:block;scale: 2;top: 65%;left: 68%;";
            } else if (index == 2) {
              this.$refs[`flower-item-${i + 1}`][0].style =
                "display:block;scale: 2;top: 50%;left: 69%;";
            } else if (index == 3) {
              this.$refs[`flower-item-${i + 1}`][0].style =
                "display:block;scale: 2;top: 35%;left: 90%;";
            } else if (index == 4) {
              this.$refs[`flower-item-${i + 1}`][0].style =
                "display:block;scale: 2;top: 66%;left: 90%;";
            } else if (index == 5) {
              this.$refs[`flower-item-${i + 1}`][0].style =
                "display:block;scale: 2;top: 90%;left: 90%;";
            } else if (index == 6) {
              this.$refs[`flower-item-${i + 1}`][0].style =
                "display:block;scale: 2;top: 85%;left: 70%;";
            } else if (index == 7) {
              this.$refs[`flower-item-${i + 1}`][0].style =
                "display:block;scale: 2;top: 90%;;left: 50%;";
            } else if (index == 8) {
              this.$refs[`flower-item-${i + 1}`][0].style =
                "display:block;scale: 2;top: 62%;left: 45%;";
            } else if (index == 9) {
              this.$refs[`flower-item-${i + 1}`][0].style =
                "display:block;scale: 2;top: 50%;left: 45%;";
            }
          } else {
            this.$refs[`flower-item-${i + 1}`][0].style = "display:none;";

            if (index != 1 && i + 1 == 1) {
              if (index == 1) {
                // this.$refs[`flower-item-1`][0].style = "display:block;top: 60%;left: 60%;";
              } else if (index == 2) {
                this.$refs[`flower-item-1`][0].style =
                  "display:block;top: 80%;left: 50%;";
              } else if (index == 3) {
                this.$refs[`flower-item-1`][0].style =
                  "display:block;top: 65%;left: 30%;";
              } else if (index == 4) {
                this.$refs[`flower-item-1`][0].style =
                  "display:block;top: 50%;left: 20%;";
              } else if (index == 5) {
                this.$refs[`flower-item-1`][0].style =
                  "display:block;top: 30%;left: 30%;";
              } else if (index == 6) {
                this.$refs[`flower-item-1`][0].style =
                  "display:block;top: 15%;left: 51%;";
              } else if (index == 7) {
                this.$refs[`flower-item-1`][0].style =
                  "display:block;top: 30%;left: 80%;";
              } else if (index == 8) {
                this.$refs[`flower-item-1`][0].style =
                  "display:block;top: 45%;left: 75%;";
              } else if (index == 9) {
                this.$refs[`flower-item-1`][0].style =
                  "display:block;top: 79%;left: 70%;";
              }
            }
          }
        }
      } else if (index == 1) {
        this.type = "one";
        this.overlayShow = false;
        // 全部恢复
        for (let i = 0; i < this.list.length; i++) {
          this.$refs[`flower-item-${i + 1}`][0].style = "display:block;";
        }
      } else if (this.type == "two") {
        // 关闭蒙版

        this.closeOverlay();
        return;
      }
    },
    closeOverlay() {
      // console.log("关闭蒙版");
      this.overlayShow = false;
      this.type = "one";
      // 全部恢复
      for (let i = 0; i < this.list.length; i++) {
        this.$refs[`flower-item-${i + 1}`][0].style = "display:block;";
      }
    },
  },
};
</script>

<style lang="scss">
.flower {
  width: 6.2rem;
  height: 6.2rem;
  display: flex;
  position: relative;
  // pointer-events: none;
  &-overlay {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    pointer-events: all;
  }

  &-one {
    z-index: 2;
    width: 100%;
    height: 100%;
    // background: url(~@/assets/evaluation/type/one_type_img.png) no-repeat;
    background-size: 100% 100%;
    position: absolute;

    &-item {
      position: absolute;
      // color: #fff;
      font-weight: bold;
      text-align: center;
      text-wrap: wrap;
      font-size: 0.24rem;
      // padding: 0.2rem;
      transition: 0.6s;
      transform-origin: center center;

      img {
        width: 1.5rem;
        height: 1.5rem;
      }

      &-text {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 0.25rem;
        color: #fff;
        width: 0.6rem;
        pointer-events: none;
      }

      &-one {
        color: #fff;
        position: absolute;
        font-size: 0.2rem;
        // display: contents;
        pointer-events: none;
      }

      &-two {
        color: #fff;
        position: absolute;
        font-size: 0.2rem;
        top: 0;
        // display: contents;
        pointer-events: none;
      }

      &-three {
        color: #fff;
        position: absolute;
        top: 0;
        font-size: 0.18rem;
        // display: contents;
        pointer-events: none;
      }

      &:nth-child(1) {
        left: 51%;
        top: 50%;
        transform: translate(-50%, -50%);
        font-size: 0.25rem;
        color: #000;
        .flower-one-item-text {
          color: #000;
        }
        .flower-one-item-one {
          top: 40%;
          left: 40%;
        }

        .flower-one-item-two {
          left: 5%;
          display: flex;
          flex-direction: column;

          top: 7%;
          width: 100%;
          height: 100%;
          padding: 0 0.28rem;

          &-text {
            color: #000;

            width: 0.5rem;
            position: absolute;

            &:nth-child(1) {
              left: 15%;
              top: 32%;
            }

            &:nth-child(2) {
              right: 26%;
              top: 17%;
            }
          }
        }

        .flower-one-item-three {
          width: 100%;
          height: 100%;
          font-size: 0.16rem;
          &-text {
            color: #000;

            width: 0.6rem;
            position: absolute;

            &:nth-child(1) {
              left: 20%;
              top: 22%;
            }

            &:nth-child(2) {
              right: 20%;
              top: 22%;
            }

            &:nth-child(3) {
              bottom: 23%;
              left: 50%;
              transform: translateX(-50%);
            }
          }
        }
      }

      &:nth-child(2) {
        left: 51%;
        top: 16%;
        transform: translate(-50%, -50%);

        img {
          width: 1.1rem;
          height: 2rem;
        }

        .flower-one-item-text {
          top: 35%;
        }

        .flower-one-item-one {
          top: 25%;
          left: 30%;
        }

        .flower-one-item-two {
          left: 5%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          top: 7%;
          width: 100%;
          padding: 0 0.28rem;

          &-text {
            width: 0.2rem;
            position: absolute;
            &:nth-child(1) {
              left: 30%;
              top: 15%;
            }

            &:nth-child(2) {
              right: 43%;
              top: 15%;
            }
          }
        }

        .flower-one-item-three {
          width: 100%;
          height: 100%;

          &-text {
            width: 0.4rem;
            position: absolute;

            &:nth-child(1) {
              left: 30%;
              top: 15%;
            }

            &:nth-child(2) {
              right: 30%;
              top: 15%;
            }

            &:nth-child(3) {
              bottom: 18%;
              left: 50%;
              transform: translateX(-50%);
            }
          }
        }
      }

      &:nth-child(3) {
        left: 75%;
        top: 25%;
        transform: translate(-50%, -50%);

        .flower-one-item-text {
          top: 40%;
          left: 60%;
        }

        .flower-one-item-one {
          top: 30%;
          left: 45%;
        }

        .flower-one-item-two {
          left: 5%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          // top: 7%;
          width: 100%;
          height: 100%;
          padding: 0 0.28rem;
          font-size: 0.15rem;

          &-text {
            width: 0.4rem;
            position: absolute;

            &:nth-child(1) {
              left: 32%;
              top: 12%;
            }

            &:nth-child(2) {
              right: 30%;
              top: 40%;
            }
          }
        }

        .flower-one-item-three {
          width: 100%;
          height: 100%;
          font-size: 0.15rem;

          &-text {
            width: 0.4rem;
            position: absolute;

            &:nth-child(1) {
              left: 37%;
              top: 7%;
            }

            &:nth-child(2) {
              right: 16%;
              top: 35%;
            }

            &:nth-child(3) {
              bottom: 25%;
              left: 32%;
              transform: translateX(-50%);
            }
          }
        }
      }

      &:nth-child(4) {
        left: 85%;
        top: 49%;
        transform: translate(-50%, -50%);

        img {
          width: 1.8rem;
          height: 1.1rem;
        }

        .flower-one-item-text {
          top: 40%;
          left: 60%;
        }

        .flower-one-item-one {
          top: 35%;
          left: 28%;
        }

        .flower-one-item-two {
          left: 5%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          // top: 7%;
          width: 100%;
          height: 100%;
          padding: 0 0.28rem;
          font-size: 0.15rem;

          &-text {
            // width: 0.4rem;
            position: absolute;

            &:nth-child(1) {
              left: 45%;
              top: 30%;
            }

            &:nth-child(2) {
              right: 15%;
              top: 50%;
            }
          }
        }

        .flower-one-item-three {
          width: 100%;
          height: 100%;
          font-size: 0.15rem;

          &-text {
            width: 0.55rem;
            position: absolute;

            &:nth-child(1) {
              left: 55%;
              top: 20%;
            }

            &:nth-child(2) {
              right: 12%;
              top: 45%;
            }

            &:nth-child(3) {
              bottom: 45%;
              left: 35%;
              transform: translateX(-50%);
            }
          }
        }
      }

      &:nth-child(5) {
        left: 75%;
        top: 74%;
        transform: translate(-50%, -50%);

        .flower-one-item-one {
          top: 34%;
          left: 22%;
        }

        .flower-one-item-two {
          left: 5%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          // top: 7%;
          width: 100%;
          height: 100%;
          padding: 0 0.28rem;
          font-size: 0.15rem;

          &-text {
            // width: 0.4rem;
            position: absolute;
            width: 0.5rem;

            &:nth-child(1) {
              left: 55%;
              top: 35%;
            }

            &:nth-child(2) {
              right: 45%;
              top: 55%;
            }
          }
        }

        .flower-one-item-three {
          width: 100%;
          height: 100%;
          font-size: 0.15rem;

          &-text {
            width: 0.55rem;
            position: absolute;

            &:nth-child(1) {
              left: 56%;
              top: 31%;
            }

            &:nth-child(2) {
              right: 40%;
              top: 56%;
            }

            &:nth-child(3) {
              bottom: 55%;
              left: 31%;
              transform: translateX(-50%);
            }
          }
        }
      }

      &:nth-child(6) {
        left: 51%;
        top: 83%;
        transform: translate(-50%, -50%);

        img {
          width: 1.1rem;
          height: 2rem;
        }

        .flower-one-item-one {
          top: 50%;
          left: 38%;
        }

        .flower-one-item-two {
          left: 5%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          // top: 7%;
          width: 100%;
          height: 100%;
          padding: 0 0.28rem;
          font-size: 0.15rem;

          &-text {
            // width: 0.4rem;
            position: absolute;
            width: 0.17rem;

            &:nth-child(1) {
              left: 50%;
              top: 45%;
            }

            &:nth-child(2) {
              right: 65%;
              top: 45%;
            }
          }
        }

        .flower-one-item-three {
          width: 100%;
          height: 100%;
          font-size: 0.15rem;

          &-text {
            width: 0.5rem;
            position: absolute;

            &:nth-child(1) {
              left: 50%;
              top: 60%;
            }

            &:nth-child(2) {
              right: 55%;
              top: 56%;
            }

            &:nth-child(3) {
              bottom: 60%;
              left: 50%;
              transform: translateX(-50%);
            }
          }
        }
      }

      &:nth-child(7) {
        left: 27%;
        top: 74%;
        transform: translate(-50%, -50%);

        .flower-one-item-text {
          top: 50%;
          left: 45%;
        }

        .flower-one-item-one {
          top: 40%;
          left: 30%;
        }

        .flower-one-item-two {
          left: 5%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          // top: 7%;
          width: 100%;
          height: 100%;
          padding: 0 0.28rem;
          font-size: 0.15rem;

          &-text {
            // width: 0.4rem;
            position: absolute;
            width: 0.5rem;

            &:nth-child(1) {
              left: 27%;
              top: 57%;
            }

            &:nth-child(2) {
              right: 60%;
              top: 30%;
            }
          }
        }

        .flower-one-item-three {
          width: 100%;
          height: 100%;
          font-size: 0.15rem;

          &-text {
            width: 0.5rem;
            position: absolute;

            &:nth-child(1) {
              left: 35%;
              top: 65%;
            }

            &:nth-child(2) {
              right: 65%;
              top: 40%;
            }

            &:nth-child(3) {
              bottom: 65%;
              left: 67%;
              transform: translateX(-50%);
            }
          }
        }
      }

      &:nth-child(8) {
        left: 18%;
        top: 49%;
        transform: translate(-50%, -50%);

        img {
          width: 1.8rem;
          height: 1.1rem;
        }

        .flower-one-item-text {
          top: 45%;
          left: 35%;
        }

        .flower-one-item-one {
          top: 38%;
          left: 20%;
        }

        .flower-one-item-two {
          left: 5%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          // top: 7%;
          width: 100%;
          height: 100%;
          padding: 0 0.28rem;
          font-size: 0.15rem;

          &-text {
            position: absolute;

            &:nth-child(1) {
              left: 20%;
              top: 25%;
            }

            &:nth-child(2) {
              right: 62%;
              top: 54%;
            }
          }
        }

        .flower-one-item-three {
          width: 100%;
          height: 100%;
          font-size: 0.15rem;

          &-text {
            width: 0.5rem;
            position: absolute;

            &:nth-child(1) {
              left: 10%;
              top: 53%;
            }

            &:nth-child(2) {
              right: 60%;
              top: 30%;
            }

            &:nth-child(3) {
              bottom: 47%;
              left: 63%;
              transform: translateX(-50%);
            }
          }
        }
      }

      &:nth-child(9) {
        left: 27%;
        top: 25%;
        transform: translate(-50%, -50%);

        .flower-one-item-text {
          top: 35%;
          left: 40%;
        }

        .flower-one-item-one {
          top: 25%;
          left: 25%;
        }

        .flower-one-item-two {
          left: 5%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          // top: 7%;
          width: 100%;
          height: 100%;
          padding: 0 0.28rem;
          font-size: 0.15rem;

          &-text {
            position: absolute;
            width: 0.5rem;

            &:nth-child(1) {
              left: 30%;
              top: 20%;
            }

            &:nth-child(2) {
              right: 65%;
              top: 40%;
            }
          }
        }

        .flower-one-item-three {
          width: 100%;
          height: 100%;
          font-size: 0.15rem;

          &-text {
            width: 0.5rem;
            position: absolute;

            &:nth-child(1) {
              left: 10%;
              top: 35%;
            }

            &:nth-child(2) {
              right: 42%;
              top: 14%;
            }

            &:nth-child(3) {
              bottom: 38%;
              left: 67%;
              transform: translateX(-50%);
            }
          }
        }
      }
    }
  }

  &-two {
    width: 100%;
    height: 100%;
    position: absolute;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .typeChangeAni-enter-active {
    animation: typeChangeAni 0.5s;
  }

  .typeChangeAni-leave-active {
    animation: typeChangeAni 0.5s reverse;
  }

  @keyframes typeChangeAni {
    from {
      // transform: translateX(-100%);
      right: -100%;
    }

    to {
      // transform: translateX(0px);
      right: 0;
    }
  }
}

.my-shop-btn {
  animation: ani-text 1s ease-in infinite;
}

@keyframes ani-text {
  0% {
    // scale: (0.8);
    // color: red;
  }
  50% {
    // scale: (1);
    // color: blue;
  }
  100% {
    // scale: (0.8);
    // color: seagreen;
  }
}
</style>

<style>
.s0 {
  opacity: 0.1;
  fill: none;
  stroke: #ffffff;
  stroke-width: 40;
}

.s1 {
  opacity: 0.3;
  fill: none;
  stroke: rgb(250, 253, 224);
  stroke-width: 15;
}
</style>
